import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import React__default, { useContext } from 'react';

const CascadingContext = React__default.createContext({});
const CascadingProvider = (_a) => {
    var { children } = _a, value = __rest(_a, ["children"]);
    return jsx(CascadingContext.Provider, Object.assign({ value: value }, { children: children }));
};
const useCascading = () => {
    return useContext(CascadingContext);
};

export { CascadingProvider as default, useCascading };
//# sourceMappingURL=CascadingProvider.js.map
